/**
 * BriefcaseIcon/index.js
 * desc: briefcase icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const BriefcaseIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="briefcase icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.briefcase.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 20 19" xmlns="http://www.w3.org/2000/svg"><path d="M14 4h4c1.11 0 2 .89 2 2v11c0 1.11-.89 2-2 2H2c-1.11 0-2-.89-2-2L.01 6C.01 4.89.89 4 2 4h4V2c0-1.11.89-2 2-2h4c1.11 0 2 .89 2 2v2zM8 4h4V2H8v2z" /></svg>
    </IconButton>
);


export default BriefcaseIcon;
